<template>
  <div class="choose-land-container">
    <!--  中间模式组件切换，组件切换使用 show 的方式，是为了地图不重复渲染    -->
    <div class="mode-wrapper">
      <transition name="el-fade-in-linear">
        <map-mode ref="mapComp"></map-mode>
      </transition>
    </div>
    <!--  底部栏  -->
    <div class="footer-action-box" v-if="mode === 'select'">
      <div class="left">
        <div
          v-if="canSelectIds.length"
          class="all-check"
          :class="{ checked: isSelectAllLand }"
          @click="handleSelectAll"
        >
          <div class="check-icon">
            <i class="iconfont icon-round-check"></i>
          </div>
          <span>全选</span>
        </div>
        <div
          v-if="landIdListOfCrop.length"
          class="all-check"
          :class="{ checked: isSelectAllCorpLand }"
          @click="handleSelectAllCorp"
        >
          <div class="check-icon">
            <i class="iconfont icon-round-check"></i>
          </div>
          <span>全选{{ query.cropGroupName }}种植地块</span>
        </div>
      </div>

      <div class="bottom-right">
        <div class="selected-info">
          <span slot="reference" class="reference"
            >已选择<span>{{ hadSelectedLandList.length }}</span
            >个地块（共<span>{{ totalAcre }}</span
            >亩）</span
          >
          <span>温馨提示：置灰地块不可选（已下单地块）</span>
        </div>
        <el-button class="submit-btn" @click="submitHandle">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import MapMode from "./MapMode";
import { mapState, mapGetters } from "vuex";
import { getnjLandList, getListOrderLand } from "@/api/request/snkd.njDispatch";
import { addFloatNumber, maxDecimalPlaces } from "@/utils";
import { getStorage } from "@/utils/storage";
const farmInfo = getStorage("FARMINFO");
const companynfo = getStorage("COMPANYINFO");
const unit = [0, 666.7, 66.67, 1]; // 一亩为666.7平方米 分 平方米
export const shAreaIds = [
  "310113",
  "310230",
  "310120",
  "310114",
  "310116",
  "310115",
  "310118",
  "310117",
  "310112",
  "310181",
  "310182",
  "310183",
];
export default {
  components: { MapMode },
  props: {
    selectLandLists: {
      type: Array,
      default: () => [],
    },
    selectCropGroupId: {
      type: String,
      default: "",
    },
    selectCropId: {
      type: String,
      default: "",
    },
    mode: {
      type: String,
      default: "select",
    },
    query: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      companyId: null,
      farmId: null,
      canSelectIds: [],
      landIdListOfCrop: [],
      showShanghaiMap: true,
    };
  },
  computed: {
    ...mapState("njwork", {
      filterLandCondition: "filterLandCondition",
      loading: "landLoading",
    }),
    ...mapGetters("njwork", [
      "hadSelectedLandList",
      "isSelectAllLand",
      "showLandList",
    ]),
    //求和
    totalAcre() {
      return this.calcLandAcre(this.hadSelectedLandList);
    },
    isSelectAllCorpLand() {
      if (!this.landIdListOfCrop.length) {
        return false;
      }
      return this.landIdListOfCrop.every((item) =>
        this.hadSelectedLandList.map((item) => item.id).includes(item)
      );
    },
  },
  async mounted() {
    this.showShanghaiMap =
      shAreaIds.includes(String(farmInfo.countyId)) &&
      companynfo.supervisionFlag;
    if (this.mode == "select") {
      await this.getLandListHandle();
    } else {
      this.getListOrderLands();
    }
  },
  methods: {
    async getListOrderLands() {
      const res = await getListOrderLand({ orderId: this.query.orderId });
      if (res.respCode == 0) {
        this.$store.commit("njwork/setLandList", res.obj);
        this.$store.commit("njwork/changeLoadingStatus", false);
        this.$store.commit("njwork/setShowState", true);
      }
    },
    //获取地块列表
    async getLandListHandle() {
      //如果没有已选地块
      if (!this.hadSelectedLandList.length) {
        const res = await getnjLandList({
          workTypeId: this.query.workTypeId,
          cropGroupId: this.query.cropGroupId,
        });
        let data = res.obj.landNjMapVOList;

        if (res.respCode == 0) {
          if (data) {
            // 可以选择的地块
            this.canSelectIds = data
              .filter((item) => !item.disable)
              .map((item) => item.id);
            data = data.map((item) => {
              item.select = false;
              item.disable = false;
              //usedFlag  是否已下单 1是 0否 已下单地块展示灰色
              if (item.usedFlag) {
                item.disable = true;
              }
              return item;
            });
            this.getLandOfTheCrop(data);
            await this.processShowLandList(data);
            if (this.selectLandLists && this.selectLandLists.length) {
              this.selectLandLists.forEach((item) => {
                this.$store.commit("njwork/changeSelectStatus", item);
              });
            }
          }
        }
      }
      // 请求结束，loading 状态设为 false
      this.$store.commit("njwork/changeLoadingStatus", false);
      this.$store.commit("njwork/setShowState", false);
    },
    getLandOfTheCrop(list) {
      this.landIdListOfCrop = list
        .filter((item) => {
          if (item.disable) return false;
          var crops = item.cropList.map((item) => {
            return item.cropGroupId;
          });
          if (!crops.length) return;
          return crops.includes(this.query.cropGroupId);
        })
        .map((land) => Number(land.id));
    },
    //选择地块确定
    submitHandle() {
      this.$emit("selectLandList", this.hadSelectedLandList, this.totalAcre);
      this.$emit("submit");
    },
    //求和
    calcLandAcre(list) {
      let acreLandAcre = 0;
      if (
        list.length &&
        Reflect.has(list[0], "acreLandAcre") &&
        list[0]["acreLandAcre"]
      ) {
        acreLandAcre = list.reduce(
          (sum, land) => addFloatNumber(sum, land.acreLandAcre),
          0
        );
        acreLandAcre = maxDecimalPlaces(acreLandAcre);
      } else {
        acreLandAcre = list.reduce((sum, land) => {
          var landAcre =
            unit[land["landAcreUnit"]] * parseFloat(land["landAcre"]);
          return addFloatNumber(sum, landAcre);
        }, 0);
        acreLandAcre = maxDecimalPlaces(acreLandAcre / 666.7);
      }
      return acreLandAcre;
    },
    // 处理保存地块数据
    processShowLandList(data) {
      data.forEach((item) => {
        item.select = false;
        item.landId = item.id;
      });
      const arr = data.filter((it) =>
        this.showShanghaiMap ? it["shGisPath"] : it["path"]
      );
      this.$store.commit("njwork/setLandList", arr);
    },
    //全选
    handleSelectAll() {
      const data = {
        selectStatus: !this.isSelectAllLand,
        showLandList: this.showLandList,
      };
      this.$store.commit("njwork/selectAllLand", data);
      this.$refs.mapComp.renderMap();
    },
    handleSelectAllCorp() {
      if (this.isSelectAllCorpLand) {
        this.landIdListOfCrop.forEach((item) => {
          return this.$store.commit("njwork/cancleAllCorpStatus", item);
        });
      } else {
        this.landIdListOfCrop.forEach((item) => {
          this.$store.commit("njwork/selectAllCorpStatus", item);
        });
      }
      this.$refs.mapComp.renderMap();
    },
  },
};
</script>

<style lang="scss">
.choose-land-container {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  background: #ffffff;
  .mode-wrapper {
    height: calc(100% - 67px);
    overflow: hidden;
  }
  .footer-action-box {
    .left {
      display: flex;
    }
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: absolute;
    // left: 0;
    // bottom: 0;
    width: 100%;
    height: 67px;
    background: #ffffff;
    box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    .all-check {
      display: flex;
      margin: 0 16px 0 32px;
      cursor: pointer;
      .check-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #e5e5e5;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 12px;
        i {
          font-size: 12px;
          color: #ffffff;
          margin: 0;
        }
      }
      span {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
      }
      &.checked {
        .check-icon {
          background: $--color-primary;
          border: 0 none;
        }
        span {
          color: $--color-primary;
        }
      }
    }
    .selected-info {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      line-height: 40px;
      color: #b2b2b2;
      span {
        height: 20px;
        line-height: 20px;
        text-align: right;
      }
      .reference {
        color: $--color-primary;
        font-size: 14px;
      }
      .icon-shang1 {
        margin: 0;
        display: inline-block;
        font-size: 14px;
        color: #bfbfbf;
        transition: all 0.3s;

        &.rotate {
          transition: all 0.3s;
          transform: rotate(-180deg);
        }
      }
    }
    .next-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 122px;
    }
    .submit-btn {
      margin-left: 20px;
      width: 90px;
      height: 35px;
      background: #64c3a4;
      border-radius: 30px;
      color: #fff;
      line-height: 10px;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
    }
    .bottom-right {
      position: relative;
      margin-right: 30px;
      display: flex;
    }
  }
}
</style>
